import { db } from "../Config";

export const fetchGastosFijos = async (empresaId) => {
  let gastosFijosRef = db.collection("empresas").doc(empresaId).collection("gastosFijos");
  let datos = {
    empresaId: "",
    fecha: "",
    total: 0,
    dias: 0,
    horas: 0,
    items: [],
  };
  try {
    const querySnapshot = await gastosFijosRef.get();
    if (querySnapshot.empty) {
      // Si no hay gastos fijos, obtener los generales
      return await fetchGastosFijosGeneral();
    } else {
      querySnapshot.forEach((doc) => {
        datos = doc.data();
      });
      return datos;
    }
  } catch (err) {
    throw err.message;
  }
};

export const fetchGastosFijosGeneral = async () => {
  let docRef = db.collection("configuraciones_generales").doc("gastos_fijos");
  let datos = {}
  
  try {
    const doc = await docRef.get();
    if (doc.exists) {
      datos = doc.data();    
    }
    return datos;
  } catch (err) {
    throw err.message;
  }
}



export const saveGastosFijos = async (gastos) => {
  try {
    const rootRef = db.collection("empresas").doc(gastos.empresaId).collection("gastosFijos");
    const gastosRef = gastos.id
      ? rootRef.doc(gastos.id)
      : rootRef.doc();
    gastos.id = gastosRef.id;
    await gastosRef.set(gastos);
    return true;
  } catch (err) {
    throw err;
  }
};
